import { render } from "./LoginRoot.vue?vue&type=template&id=30d255de&scoped=true&lang=pug"
import script from "./LoginRoot.vue?vue&type=script&lang=js"
export * from "./LoginRoot.vue?vue&type=script&lang=js"

import "./LoginRoot.vue?vue&type=style&index=0&id=30d255de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d255de"]])

export default __exports__